import types from './types.js'
import documents from './documents.js'
import taxes from './taxes.js'

export default {
  menu: 'Accounting',
  title: 'Accounting',

  types,

  documents,

  taxes
}
